<template>
  <div class="index">
    <div class="common_mbx">
      您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link> > 案例
    </div>
    <div class="common_wrap">
      <p class="cases_title">客户案例</p>
      <div class="cases_tabs">
        <div :class="{cases_tab:true, active:index==15}" @click='index=15'>全部案例</div>
        <div :class="{cases_tab:true, active:index==item.id}"  v-for='item in data' @click='index=item.id'>{{item.name}}</div>
      </div>
      <div class="cases_items clearfix animated slideInRight" v-if='list.length>0'>
        <template v-for='(item,index) in list'>
          <div :class="{case_item:true, big:index==0}">
            <router-link :to='"/our/cases/detail/"+item.id'>
              <img :src="domain+item.litpic">
              <div class="case_name">
                <div>
                <i class="search"></i>
                <p class="name">{{item.title}}</p>
                </div>
              </div>
            </router-link>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import animatecss from 'animate.css'
export default {
  name: 'app',
  data(){
    return{
      data:[],
      index:'',
      list:[],
      domain:''
    }
  },
  watch:{
    '$route':function(to,from){
      this.index=this.$route.params.id
      this.getCategory()
      //this.getList()
    },
    'index':function(){
      this.list=[]
      this.getList()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain
    this.getCategory()
    //this.getList()
    this.index=this.$route.params.id
  },
  methods:{
    getCategory:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        cid:15
      }))
      .then(response => {
        console.log(response);
        this.data=response.data.data
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
        this.getList()
      })
      .catch(error => {
        console.log(error);
      });
    },
    getList:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_picture_lists', this.$qs.stringify({
        cid:this.index,
        page:1,
        limit:1000
      }))
      .then(response => {
        console.log(response);
        this.list=response.data.data
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>

 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .cases_title{
  font-size: 24px;
  color: #000;
  text-align: center;
  margin-bottom: 40px;
 }
 .cases_tabs{
  text-align: center;
  margin-bottom: 34px;
 }
 .cases_tab:last-child{
  margin-right: 0;
 }
 .cases_tab{
  display: inline-block;
  margin-right: 40px;
  width: 100px;
  font-size: 14px;
  color: #000;
  padding-bottom: 18px;
  cursor: pointer;
 }
 .cases_tab.active{
  border-bottom: 4px solid #3478f7;
  color: #3478f7;
  box-sizing: border-box;
 }
 .case_item.big{
  width: 100%;
 }
 .case_item{
  width: 598px;
  float: left;
  position: relative;
  margin-bottom: 4px;
  margin-right: 4px;
  height: 400px;
  overflow: hidden;
 }
 .case_item:nth-child(2n+1){
  margin-right: 0;
 }
 .case_item img{
  width: 100%;
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
 }
 .cases_items{
  margin-bottom: 30px;
 }
 .case_item:hover .case_name{
 /*  display: block; */
  opacity: 1;
  transition: all .5s;
 }
 .case_name{
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
 /*  display: none; */
  opacity: 0;
 }
 .case_name>div{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
 }
 .case_name>div .name{
  font-size: 14px;
  color: #fff;
  margin-top: 15px;
 }
 .search{
  background-image: url('../../static/images/search.png');
  display: inline-block;
  width: 30px;
  height: 30px;
 }
</style>


// WEBPACK FOOTER //
// src/components/cases.vue